import { BottleSodaClassicIcon } from './BottleSodaClassicIcon';

/**
 * author: Michael Richins
 * id E62A084A-2136-4FD3-8803-A72DE26D60CB
 * name bottle-soda-classic
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bottle-soda-classic.svg
 * tags
 * - Food / Drink 
 */
export const BottleCokeClassicIcon = BottleSodaClassicIcon;
export default BottleCokeClassicIcon